import React from "react";
import type { Project } from "../../../../../api/useProjects";
import BlankStateV2 from "@ui/BlankStateV2";
import ScreenGraph from "@ui/Picto/ScreenGraph";
import { useNavigate } from "react-router";
import t from "../../../../../i18n";
import { toPath } from "../../../../../router/helpers/path";

const BlankStateDiagnosis = ({ project }: { project: Project }) => {
  const navigate = useNavigate();

  return (
    <BlankStateV2
      picto={<ScreenGraph />}
      title={t("common.empty.activeAnalyses.title")}
      subtitle={t("common.empty.activeAnalyses.description")}
      onClick={() =>
        navigate(
          toPath("/projects/:projectId/measures", {
            projectId: project.id,
          }),
        )
      }
      buttonLabel={t("common.empty.activeAnalyses.action")}
    />
  );
};
export default BlankStateDiagnosis;
